"use client";

import { useIsPWA } from "@/hooks/use-is-pwa";
import { PWABottomNav } from "@/components/layout/pwa-bottom-nav";
import { ReactNode } from "react";

interface LayoutContentProps {
  children: ReactNode;
  header: ReactNode;
  footer: ReactNode;
  pwaHeader: ReactNode;
  isAuthenticated: boolean;
  isAdmin: boolean;
  displayName?: string;
}

/**
 * Client-side layout wrapper that conditionally renders header/footer
 * based on whether the app is running as a PWA
 */
export function LayoutContent({ 
  children, 
  header, 
  footer, 
  pwaHeader,
  isAuthenticated,
  isAdmin,
  displayName
}: LayoutContentProps) {
  const isPWA = useIsPWA();

  if (isPWA) {
    // PWA Layout: Custom header + bottom nav
    return (
      <>
        {pwaHeader}
        
        {/* Main content with extra padding for bottom nav and iOS safe areas */}
        <main className="flex-1 pb-24" style={{ paddingBottom: 'calc(5rem + env(safe-area-inset-bottom, 0px))' }}>
          {children}
        </main>
        
        {/* Bottom navigation with profile dropdown */}
        <PWABottomNav 
          isAuthenticated={isAuthenticated} 
          isAdmin={isAdmin}
          displayName={displayName}
        />
      </>
    );
  }

  // Browser Layout: Traditional header + footer
  return (
    <>
      {header}
      <main className="flex-1">{children}</main>
      {footer}
    </>
  );
}

